import './style.scss'
import '../../Secondary/MarketsTop/style.scss'
import StatsSection from 'components/Secondary/StatsSection';
import StatisticsChart from 'components/Secondary/StatisticsChart';
import ButtonSelector from 'components/Secondary/ButtonSelector';
import {ReactComponent as Calendar} from "assets/icons/calendar.svg";
import {ReactComponent as Printer} from "assets/icons/printer.svg";
import TradingHistoryTable from './TradingHistoryTable';
import FooterPagination from 'components/Secondary/FooterPagination';
import { useState } from 'react';

const mock = [
  {price: 123, date: 1652932911000},
  {price: 2, date: 1652932912000},
  {price: 1234, date: 1652932913000},
]

const TradingHistory = ({}) => {
  const[selected, setSelected] = useState(0)

  return <div className='tradingHistory'>
    <div className='historicalStats'>
      <div className='statsSection' style={{marginTop:0}}>
        <StatsSection items={[{label: "Trading Volume", value: "$18,605.44", description: "in 24 hours"}]}/>
        <div className="separator" style={{marginTop:"2.8rem"}}/>
      </div>
      <div className='chart'>
        <StatisticsChart chart={mock} xDataKey={"time"} yDataKey={"volume"} xLabelVisible={false}/>
      </div>
    </div>

    <div className="marketsTop">
      <div className='tableTop'>
        <div className="side">
          <div className='left'>
            <p className="title">
              Trading History
            </p>
          </div>
          <div className='right'>
            <ButtonSelector items={["24hr", "7d", "30d"]} selected={0}/>
            <Calendar className='icon'/>
            <Printer className='icon'/>
          </div>
        </div>
      </div>
    </div>

    <TradingHistoryTable/>

    <div className='pagination'>
      <FooterPagination selected={selected} setSelected={setSelected} numPages={15}/>
    </div>
  </div>
}

export default TradingHistory;